import Modal from 'components/Layout/Modal';
import React from 'react';
import Button from 'components/form/Button';
import { useParams } from 'react-router-dom';
import Dropdown from 'components/form/Dropdown';
import TextInput from 'components/form/TextInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const CouponPopup = ({ onHide, event_id }) => {
  const params = useParams();
  const { eID } = params;

  const discountOptions = [
    { id: '10%', label: '10%' },
    { id: '20%', label: '20%' },
  ];

  const validationSchema = Yup.object().shape({
    discount: Yup.string().required('Discount is required'),
    coupon: Yup.string().required('Coupon code is required'),
  });

  const initialValues = {
    discount: '',
    coupon: '',
  };

  const handleSubmit = (values) => {
    console.log('Form Values:', values);
    // You can call your API here with `values`
  };

  return (
    <Modal
      size="md"
      onHide={onHide}
      titleBesideClose="Add Coupon & Discount"
      titleBesideCloseClassName="cps-15"
      isTitleBorder
      isTitleVerticalCenter
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
          <Form>
            <div className="cpt-20 cpb-20 add-user-container">
              <div className="cmt-5 cps-32 cpe-60">
                <Dropdown
                  id="discount"
                  label="Discount"
                  placeholder="Select Discount"
                  options={discountOptions}
                  value={values.discount}
                  error={touched.discount && errors.discount}
                  onChange={(e) => setFieldValue('discount', e.target.value)}
                />

                <div className="cmt-5">
                  <TextInput
                    label="Coupon"
                    placeholder="Enter coupon code"
                    id="coupon"
                    value={values.coupon}
                    error={touched.coupon && errors.coupon}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>

              <div className="cmt-30 cps-32 cpe-32">
                <div className="d-flex align-items-center gap-3">
                  <Button
                    text="Save & Continue"
                    btnStyle="primary-dark"
                    className="h-35 cps-20 cpe-20"
                    type="submit"
                  />
                  <Button
                    text="Skip Now"
                    btnStyle="primary-light-outline"
                    className="h-35 cps-20 cpe-20"
                    onClick={() => {
                      // Optional skip handler
                      onHide();
                    }}
                  />
                  <Button
                    text="Cancel"
                    btnStyle="light-outline"
                    className="h-35 cps-20 cpe-20"
                    onClick={onHide}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CouponPopup;
